import styled from '@emotion/styled';
import { colors } from '@innovationdepartment/proxima-ui';

import { Header } from 'ui/Header';

const SectionWrapper = styled.div`
  background-color: ${colors.white};
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

const SectionHeader = styled.div`
  padding: 0 32px;
  border-bottom: 1px solid ${colors.neutral20};
  background-color: ${colors.neutral5};
  display: flex;
  flex-flow: column;
`;

/* The Header centres its title in a fixed-height bar, so the negative bottom margin leaves about 8px between this row and the title text */
const AboveTitle = styled.div`
  padding-top: 16px;
  margin-bottom: -10px;
`;

const SectionContent = styled.div`
  overflow: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 32px;
  gap: 32px;
`;

type SectionLayoutProps = {
  title: string;
  /** Rendered above the title, such as a back link. */
  aboveTitle?: React.ReactNode;
  headerContent?: React.ReactNode;
  /** Rendered at the right end of the title row, such as page actions. */
  titleActions?: React.ReactNode;
  titleAppendText?: React.JSX.Element;
  children?: React.ReactNode;
};

const SectionLayout: React.FC<SectionLayoutProps> = ({
  children,
  aboveTitle,
  headerContent,
  title,
  titleActions,
  titleAppendText
}) => (
  <SectionWrapper>
    <SectionHeader>
      {aboveTitle ? <AboveTitle>{aboveTitle}</AboveTitle> : null}
      <Header title={title} titleAppendText={titleAppendText}>
        {titleActions}
      </Header>
      {headerContent}
    </SectionHeader>
    <SectionContent>{children}</SectionContent>
  </SectionWrapper>
);

export default SectionLayout;
